/**
 * @file index.tsx
 * @deprecated Copied to app/modules/procurement/pages/goods-received-note/index.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/goods-received-note/index
 * @description Router container for Goods Received Note (GRN) module. Defines routes for GRN 
 *   list, details, and goods receipt workflow. Manages navigation between sub-pages and maintains 
 *   page title/breadcrumb context using uTrade layout components.
 * 
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo [P2] Fix breadcrumb route paths to match registered private routes
 *   and prevent broken breadcrumb navigation.
 * @todo [P3] Add route-level permission guards using GoodsReceivedNote or equivalent
 *   permission constant from utils/constants.ts.
 */

import { Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_admin/layout/core";
import GRNList from "./grn-list";
import GRNDetails from "./grn-details";
import AddGoodsToInventory from "./add-goods-to-inventory";
const goodsReceivedNoteBreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const goodsReceivedNotev2BreadCrumbs: Array<PageLink> = [
  {
    title: 'UProcure',
    path: '/UProcure',
    isSeparator: false,
    isActive: false,
  },
  {
    title: 'Goods Received Notes',
    path: '/goods-received-note',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];
const GoodsReceivedNotePage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        path="/"
        element={
          <>
            <PageTitle breadcrumbs={goodsReceivedNoteBreadCrumbs}>
              Goods Received Notes
            </PageTitle>
            <GRNList />
          </>
        }
      />
      <Route
        path="grn-details"
        element={
          <>
            <PageTitle breadcrumbs={goodsReceivedNotev2BreadCrumbs}>
              Goods Received Note Details
            </PageTitle>
            <GRNDetails />
          </>
        }
      />
      <Route
        path="add-goods-to-inventory"
        element={
          <>
            <PageTitle breadcrumbs={goodsReceivedNotev2BreadCrumbs}>
              Add Goods to Inventory
            </PageTitle>
            <AddGoodsToInventory />
          </>
        }
      />
    </Route>
  </Routes>
);
export default GoodsReceivedNotePage;
